import { memo } from 'react';

import PropTypes from 'prop-types';

import AppEmptyState from '@components/common/AppEmptyState';

const AppNoData = memo(function AppNoData({
  title = 'No data found',
  description = 'There is no data available for this view.',
  action,
  ...rest
}) {
  return <AppEmptyState title={title} description={description} action={action} {...rest} />;
});

AppNoData.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  action: PropTypes.node,
};

export default AppNoData;
